import * as React from 'react';
import styled from '@emotion/styled';
import { useSystem } from '../../../hooks/useSystem';
import { observer } from 'mobx-react';
import { useNavigate } from 'react-router-dom';
import { SidebarButtonWidget } from '../sidebar/SidebarButtonWidget';
import { Routing } from '../../../pages/Routing';
import { Font } from '../../../fonts';

export interface UserSidebarWidgetProps {
  close: () => any;
}

export const UserSidebarWidget: React.FC<UserSidebarWidgetProps> = observer((props) => {
  const system = useSystem();
  const navigate = useNavigate();
  return (
    <S.Container>
      <S.Top>
        <S.Profile>{system.user?.data?.profile_name}</S.Profile>
      </S.Top>
      <S.Main>
        <SidebarButtonWidget
          label="My Profile"
          action={() => {
            navigate(system.user.link, { state: 'push' });
            props.close();
          }}
        />
        <SidebarButtonWidget
          label="Edit profile"
          action={() => {
            navigate(Routing.EDIT_PROFILE, { state: 'push' });
            props.close();
          }}
        />
        <SidebarButtonWidget
          label="Edit profile picture"
          action={() => {
            navigate(Routing.EDIT_AVATAR, { state: 'push' });
            props.close();
          }}
        />
        <SidebarButtonWidget
          label="Registration codes"
          action={() => {
            navigate(Routing.REGISTRATION_CODES, { state: 'push' });
            props.close();
          }}
        />
        <SidebarButtonWidget
          label="Create Pack"
          action={() => {
            navigate(Routing.PACK_CREATE, { state: 'push' });
            props.close();
          }}
        />
        <SidebarButtonWidget
          label="Create Group"
          action={() => {
            navigate(Routing.GROUP_CREATE, { state: 'push' });
            props.close();
          }}
        />
      </S.Main>
      <S.Bottom>
        <SidebarButtonWidget
          label="Sign out"
          action={() => {
            system.session_store.logout();
          }}
        />
      </S.Bottom>
    </S.Container>
  );
});
namespace S {
  export const Container = styled.div`
    display: flex;
    flex-direction: column;
    min-height: 100%;
    box-sizing: border-box;
  `;

  export const Main = styled.div`
    flex-grow: 1;
    min-height: 100%;
    padding: 5px;
  `;

  export const Bottom = styled.div`
    padding: 5px;
    border-top: solid 1px ${(p) => p.theme.layout.border};
  `;

  export const Profile = styled.div`
    color: ${(p) => p.theme.text.primary};
    font-family: ${Font.Special};
    font-size: 15px;
    padding: 10px;
  `;

  export const Top = styled.div`
    height: 50px;
    align-items: center;
    display: flex;
    border-bottom: solid 1px ${(p) => p.theme.layout.border};
  `;
}
